import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { propTypes, reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { Card, CardActions } from 'material-ui/Card'
import Avatar from 'material-ui/Avatar'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'
import CircularProgress from 'material-ui/CircularProgress'
import LockIcon from 'material-ui/svg-icons/action/lock-outline'
import { cyan500, pinkA200 } from 'material-ui/styles/colors'

import defaultTheme from 'admin-on-rest'
import { userLogin as userLoginAction } from 'admin-on-rest'
import { translate } from 'admin-on-rest'
import { Notification } from 'admin-on-rest'
import { showNotification as showNotificationAction } from 'admin-on-rest'

import * as firebase from 'firebase'

import { createHashHistory } from 'history'
export const history = createHashHistory()

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    minWidth: 300,
  },
  avatar: {
    margin: '1em',
    textAlign: 'center ',
  },
  form: {
    padding: '0 1em 1em 1em',
  },
  input: {
    display: 'flex',
  },
}

function getColorsFromTheme(theme) {
  if (!theme) return { primary1Color: cyan500, accent1Color: pinkA200 }
  const { palette: { primary1Color, accent1Color } } = theme
  return { primary1Color, accent1Color }
}

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
  meta: { touched, error } = {},
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    errorText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
)

class ForgotPage extends Component {
  login = formData => {
    const { showNotification } = this.props

    firebase
      .auth()
      .sendPasswordResetEmail(formData.email)
      .then(() => {
        showNotification('aor.auth.email_reset_sent')
      })
      .catch(error => {
        showNotification('aor.auth.invalid_email')
      })
  }

  render() {
    const { handleSubmit, submitting, theme, translate } = this.props
    const muiTheme = getMuiTheme(theme)
    const { primary1Color, accent1Color } = getColorsFromTheme(muiTheme)
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={{ ...styles.main, backgroundColor: primary1Color }}>
          <Card style={styles.card}>
            <div style={styles.avatar}>
              <Avatar
                backgroundColor={accent1Color}
                icon={<LockIcon />}
                size={60}
              />
            </div>
            <form onSubmit={handleSubmit(this.login)}>
              <div style={styles.form}>
                <div style={styles.input}>
                  <Field
                    name="email"
                    component={renderInput}
                    floatingLabelText={translate('aor.auth.email')}
                    disabled={submitting}
                  />
                </div>
              </div>
              <CardActions>
                <RaisedButton
                  type="submit"
                  primary
                  disabled={submitting}
                  icon={
                    submitting && <CircularProgress size={25} thickness={2} />
                  }
                  label={translate('aor.auth.reset_password')}
                  fullWidth
                />
                <FlatButton
                  onClick={function(event) {
                    history.push('/register')
                  }}
                  primary
                  disabled={submitting}
                  icon={
                    submitting && <CircularProgress size={25} thickness={2} />
                  }
                  label={translate(`aor.auth.create_account`)}
                  fullWidth
                />
                <FlatButton
                  onClick={function(event) {
                    history.push('/login')
                  }}
                  primary
                  disabled={submitting}
                  icon={
                    submitting && <CircularProgress size={25} thickness={2} />
                  }
                  label={translate(`aor.auth.sign_in`)}
                  fullWidth
                />
              </CardActions>
            </form>
          </Card>
          <Notification />
        </div>
      </MuiThemeProvider>
    )
  }
}

ForgotPage.propTypes = {
  ...propTypes,
  authClient: PropTypes.func,
  previousRoute: PropTypes.string,
  // theme: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  userLogin: PropTypes.func.isRequired,
}

ForgotPage.defaultProps = {
  theme: defaultTheme,
}

const enhance = compose(
  translate,
  reduxForm({
    form: 'forgot',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      if (!values.email) errors.email = translate('aor.validation.required')
      return errors
    },
  }),
  connect(null, {
    userLogin: userLoginAction,
    showNotification: showNotificationAction,
  }),
)

export default enhance(ForgotPage)



// WEBPACK FOOTER //
// ./src/auth/forgotPage.js